var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHolidayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.719,
    height: 16.123,
    viewBox: "0 0 14.719 16.123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8232",
    "data-name": "Path 8232",
    d: "M13.039,1.5A1.5,1.5,0,1,0,14.511,3,1.49,1.49,0,0,0,13.039,1.5Zm3.68,15.372a.745.745,0,0,1-.736.75h0a4.649,4.649,0,0,1-2.208-.562,4.6,4.6,0,0,1-4.482-.037,4.044,4.044,0,0,1-4.106-.1,4.62,4.62,0,0,1-2.451.7h0a.75.75,0,0,1,0-1.5h0A3.669,3.669,0,0,0,4.6,15.6a.691.691,0,0,1,.692,0,3.678,3.678,0,0,0,3.724,0,.71.71,0,0,1,.692,0,3.678,3.678,0,0,0,3.724,0,.71.71,0,0,1,.692,0,3.669,3.669,0,0,0,1.862.525h0A.745.745,0,0,1,16.719,16.872ZM6.445,14.518a2.48,2.48,0,0,0,.706.1A2.786,2.786,0,0,0,8.91,13.94a.719.719,0,0,1,.9,0,2.786,2.786,0,0,0,1.759.682,2.786,2.786,0,0,0,1.759-.682.3.3,0,0,1,.081-.052c-.339-.292-.714-.592-1.1-.877V10.858a1.5,1.5,0,0,0-.567-1.177L9.484,7.874l1.656-1.14a5.169,5.169,0,0,0,3.628,2.572.751.751,0,0,0,.221-1.485,3.686,3.686,0,0,1-2.583-1.845l-.648-1.162a1.325,1.325,0,0,0-.9-.667L7.38,3.487a1.449,1.449,0,0,0-1.1.24L4.811,4.747A.766.766,0,0,0,4.62,5.789a.737.737,0,0,0,1.03.2L7.115,4.964l1.472.277L7,6.329a1.36,1.36,0,0,0-.567,1.342L6.82,10A8.4,8.4,0,0,0,4.1,9.374c-.618,0-1.361.187-1.361.96C2.736,11.413,4.348,13.048,6.445,14.518Zm4.386-3.644V12c-.574-.36-1.722-1-2.4-1.312L8.108,8.7Z",
    transform: "translate(-2 -1.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolidayIcon);
export default __webpack_public_path__ + "static/media/holiday_icon.14554e68aa94a4937b767613e8f86f89.svg";
export { ForwardRef as ReactComponent };